import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './style.css'


class SimpleSlider extends Component {
    render() {
      var settings = {
        dots: false,
        arrows: true,
        speed: 1200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed:2500,
        fade:true
      };
      return (
        <Slider {...settings}>
          <div id="home" className="item1">
              <div className="container">
                  <div className="slide-content">
                      <div className="slide-subtitle">
                          <h4>WE'RE GETTING MARRIED</h4>
                      </div>
                      <div className="slide-title">
                          <h2>In The Redwoods</h2>
                      </div>
                      <div className="slide-text">
                          <p>September 9th, 2024</p>
                      </div>
                  </div>
              </div>
          </div>
          <div className="item2">
            <div className="container">
                <div className="container">
                      <div className="slide-content">
                          <div className="slide-subtitle">
                              <h4>YOU'RE INVITED</h4>
                          </div>
                          <div className="slide-title">
                              <h2>To Our Elopement Celebration</h2>
                          </div>
                          <div className="slide-text">
                              <p>September 28th, 2024</p>
                          </div>
                      </div>
                    </div>
                </div>
          </div>
        </Slider>
      );
    }
  }

export default SimpleSlider;